import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Currency from "utils/currency";
import { TopupOptionEdit } from './components';
import { MoneyDisplay } from 'components';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const TopupOptionInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.topup_option);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Topup Option Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Code</TableCell>
              <TableCell>{model.code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>SKU</TableCell>
              <TableCell>{model.sku}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Price</TableCell>
              <TableCell><MoneyDisplay amount={model.price} currency={model.price_currency} /></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>XXC Value</TableCell>
              <TableCell>{Currency.compress(model.denominator, "XXC")}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <TopupOptionEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

TopupOptionInfo.propTypes = {
  className: PropTypes.string,
};

export default TopupOptionInfo;
